import React from 'react';
import { motion } from 'framer-motion';
import { XCircle, Star } from 'lucide-react';
const CART_URL = 'https://www.kmsinrendirse.shop/cart/add?id=51999668764955&quantity=1';
function trackAddToCart() {
  if (typeof window !== 'undefined' && typeof window.fbq === 'function') {
    window.fbq('track', 'AddToCart');
  }
}
export function HeroSection() {
  return <section className="relative min-h-screen flex items-center pt-20 pb-16 px-4 overflow-hidden" data-id="element-60">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-gradient-to-b from-navy via-navy-light to-navy opacity-50" data-id="element-61" />

      <div className="max-w-7xl mx-auto grid md:grid-cols-2 gap-12 items-center relative z-10" data-id="element-62">
        {/* Left content */}
        <motion.div initial={{
        opacity: 0,
        x: -50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-63">
          <motion.h1 className="text-4xl md:text-6xl lg:text-7xl font-black leading-tight mb-6" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} data-id="element-64">
            De sedentario a correr{' '}
            <span className="text-accent" data-id="element-65">5K en 8 semanas</span> — sin abandonar
            a la mitad
          </motion.h1>

          <motion.p className="text-xl md:text-2xl text-gray-300 mb-8 leading-relaxed" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.4
        }} data-id="element-66">
            Si siempre empezás motivado pero lo dejás a los pocos días…{' '}
            <span className="text-white font-semibold" data-id="element-67">
              este sistema está diseñado para vos.
            </span>
          </motion.p>

          {/* Pain points */}
          <motion.div className="space-y-4 mb-10" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.6
        }} data-id="element-68">
            {['Te cansás en 2 minutos', 'Sentís que no es para vos', 'Siempre abandonás'].map((pain, i) => <motion.div key={i} className="flex items-center gap-3" initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.7 + i * 0.1
          }} data-id="element-69">
                <XCircle className="text-red-500 flex-shrink-0" size={24} data-id="element-70" />
                <span className="text-lg text-gray-300" data-id="element-71">{pain}</span>
              </motion.div>)}
          </motion.div>

          {/* CTA */}
          <motion.a href={CART_URL} target="_blank" rel="noopener noreferrer" onClick={trackAddToCart} className="inline-block bg-accent hover:bg-accent-dark text-white px-10 py-5 rounded-xl font-black text-xl transition-all hover:scale-105 shadow-lg shadow-accent/30 mb-6" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.9
        }} whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.98
        }} data-id="element-72">
            QUIERO EMPEZAR HOY
          </motion.a>

          {/* Trust indicator */}
          <motion.div className="flex items-center gap-2 text-gray-400" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1.1
        }} data-id="element-73">
            <Star className="text-yellow-400 fill-yellow-400" size={20} data-id="element-74" />
            <span className="text-sm md:text-base" data-id="element-75">
              +500 personas ya lo lograron
            </span>
          </motion.div>
        </motion.div>

        {/* Right image */}
        <motion.div className="relative" initial={{
        opacity: 0,
        x: 50
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} data-id="element-76">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl" data-id="element-77">
            <img src="https://cdn.magicpatterns.com/uploads/4V4RVgWfNfsoE2RmixoEKv/5k_sin_rendirse_(18).png" alt="5K Sin Rendirse - Portada del programa" className="w-full h-auto object-cover" data-id="element-78" />
            <div className="absolute inset-0 bg-gradient-to-t from-navy/80 to-transparent" data-id="element-79" />
          </div>
        </motion.div>
      </div>
    </section>;
}